import Vue from 'vue';

// Globals
Vue.component('NavBar', require('../../components/Navbar.vue').default);
